const thousandSeparator = (value = 0, fixed = 2) => {
  const convertValue = parseFloat(parseFloat(value).toFixed(fixed));

  const numbers = value.toLocaleString().split('.');

  if (numbers[1]) {
    return (
      convertValue.toLocaleString(undefined, { maximumFractionDigits: 2 }) +
      `${parseFloat(numbers[1]) === 0 ? '.00' : ''}`
    );
  } else {
    return (
      convertValue.toLocaleString(undefined, { maximumFractionDigits: 2 }) +
      '.00'
    );
  }
};

const numberFormat = (number, notation = 'standard') =>
  new Intl.NumberFormat('en-US', {
    notation
  }).format(number);

function parseLocaleNumber(stringNumber, locale) {
  var thousandSeparator = Intl.NumberFormat(locale)
    .format(11111)
    .replace(/\p{Number}/gu, '');
  var decimalSeparator = Intl.NumberFormat(locale)
    .format(1.1)
    .replace(/\p{Number}/gu, '');

  return parseFloat(
    stringNumber
      .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
      .replace(new RegExp('\\' + decimalSeparator), '.')
  );
}

const convertToNumber = data => {
  return +data.split(',').join('');
};

export { thousandSeparator, numberFormat, parseLocaleNumber, convertToNumber };
